import { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import fourthImg from "../assets/fourthImg.png";
import fifthImg from "../assets/fifthImg.PNG";
import eightPlexImg from "../assets/eightPlex.PNG";
import sevenPlex from "../assets/sevenPlex.PNG";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import {
  MapPin,
  Building2,
  TrendingUp,
  ArrowRight,
  Filter,
} from "lucide-react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { fetchProperties, isSupabaseConfigured } from "../lib/propertiesApi";

// const properties = [
//   {
//     id: 1,
//     name: "Modern Duplex",
//     type: "Duplex",
//     units: 2,
//     location: "Calgary, AB",
//     image: duplexImg,
//     price: "$895,000",
//     priceValue: 895000,
//     downPayment: "$44,750",
//     monthlyRent: "$3,800",
//     cashFlow: "$850",
//     roi: "12.5%",
//     equityGrowth: "$125K → $450K",
//     features: [
//       "High-end finishes",
//       "Separate entrances",
//       "Modern kitchens",
//       "Private yards",
//     ],
//     status: "Available",
//   },
//   {
//     id: 2,
//     name: "Brick Fourplex",
//     type: "Fourplex",
//     units: 4,
//     location: "Edmonton, AB",
//     image: fourplexImg,
//     price: "$1,450,000",
//     priceValue: 1450000,
//     downPayment: "$72,500",
//     monthlyRent: "$6,800",
//     cashFlow: "$1,650",
//     roi: "14.2%",
//     equityGrowth: "$180K → $650K",
//     features: [
//       "Brick exterior",
//       "Individual meters",
//       "On-site parking",
//       "Energy efficient",
//     ],
//     status: "Available",
//   },
//   {
//     id: 3,
//     name: "Urban Sixplex",
//     type: "Sixplex",
//     units: 6,
//     location: "Winnipeg, MB",
//     image: sixplexImg,
//     price: "$2,100,000",
//     priceValue: 2100000,
//     downPayment: "$105,000",
//     monthlyRent: "$10,200",
//     cashFlow: "$2,450",
//     roi: "15.8%",
//     equityGrowth: "$250K → $850K",
//     features: [
//       "Modern balconies",
//       "Elevator access",
//       "Secure entry",
//       "Storage lockers",
//     ],
//     status: "Available",
//   },
//   {
//     id: 4,
//     name: "Premium Eightplex",
//     type: "8-Unit Building",
//     units: 8,
//     location: "Saskatoon, SK",
//     image: eightplexImg,
//     price: "$2,850,000",
//     priceValue: 2850000,
//     downPayment: "$142,500",
//     monthlyRent: "$14,400",
//     cashFlow: "$3,200",
//     roi: "16.5%",
//     equityGrowth: "$350K → $1.2M",
//     features: [
//       "Luxury finishes",
//       "Rooftop terrace",
//       "Smart home tech",
//       "Fitness center",
//     ],
//     status: "Featured",
//   },
// ];
const properties = [
  {
    id: 1,
    name: "8-Plex",
    city: "Calgary",
    community: "Bowness",
    location: "8102-33 Ave NW",
    image: eightPlexImg,
    price: "$2,865,789",
    dscr: "115.27%",
    capRate: "5.75%",
    cashOnCash: "17.99%",
    roi: "142.64%",
    roiAmount: "$1,042,355",
    cashFlow: "$2,191",
    closingOn: "Closing on 26 October, 2025",
    features: ["(4 )Three BR Main", "(4) 2BR Basement"],
    status: "Available",
    downPayment: "$146,155",
  },
  {
    id: 2,
    name: "7-Plex",
    city: "Edmonton",
    community: "King Edward",
    location: "8126 -77th Ave",
    image: sevenPlex,
    price: "$2,097,899",
    dscr: "117.65%",
    capRate: "6.24%",
    cashOnCash: "23.44%",
    roi: "172.48%",
    roiAmount: "$922,728",
    cashFlow: "$2,089",
    closingOn: "Closing on 26 October, 2025",
    features: [
      "(4 )Three BR Main",
      "(3) 2BR Basement",
      "(1) 2 BR Basement NO STOVE",
    ],
    status: "Available",
    downPayment: "$106,993",
  },
  {
    id: 3,
    name: "8-Plex",
    city: "Calgary",
    community: "Forest Lawn",
    location: "740 Forlee St",
    image: eightPlexImg,
    price: "$2,587,290",
    dscr: "116.77%",
    capRate: "5.91%",
    cashOnCash: "20.06%",
    roi: "154.32%",
    roiAmount: "$1,018,143",
    cashFlow: "$2,206",
    closingOn: "Closing on 26 November, 2025",
    features: ["(4 )Three BR Main", "(4) 2BR Basement"],
    status: "Available",
    downPayment: "$131,952",
  },
  {
    id: 4,
    name: "8-Plex",
    city: "Calgary",
    community: "Forest Lawn",
    location: "1504 36TH Strret",
    image: fourthImg,
    price: "$2,745,789",
    dscr: "115.64%",
    capRate: "5.86%",
    cashOnCash: "18.73%",
    roi: "143.22%",
    roiAmount: "$1,002,818",
    cashFlow: "$2,186",
    closingOn: "Closing on 26 November, 2025",
    features: ["(4 )Three BR Main", "(4) 2BR Basement"],
    status: "Available",
    downPayment: "$140,035",
  },
  {
    id: 5,
    name: "8-Plex",
    city: "Calgary",
    community: "Bowness",
    location: "4336 72nd St",
    image: fifthImg,
    price: "$2,897,999",
    dscr: "111.54%",
    capRate: "5.54%",
    cashOnCash: "14.08%",
    roi: "138.80%",
    roiAmount: "$1,025,692",
    cashFlow: "$1,734",
    closingOn: "Closing on 26 November, 2025",
    features: ["(4 )Three BR Main", "(4) 2BR Basement"],
    status: "Available",
    downPayment: "$147,798",
  },
  {
    id: 6,
    name: "8-Plex",
    city: "Calgary",
    community: "Bowness",
    location: "6336 Bowmont Cres",
    image: eightPlexImg,
    price: "$2,897,789",
    dscr: "116.11%",
    capRate: "5.76%",
    cashOnCash: "18.89%",
    roi: "143.78%",
    roiAmount: "$1,062,478",
    cashFlow: "$2,326",
    closingOn: "Closing on 26 November, 2025",
    features: ["(4 )Three BR Main", "(4) 2BR Basement"],
    status: "Sold",
    downPayment: "$147,787",
  },
];

const AllProperties = () => {
  const [typeFilter, setTypeFilter] = useState("all");
  const [locationFilter, setLocationFilter] = useState("all");
  const [priceFilter, setPriceFilter] = useState("all");

  const { data: apiProperties = [] } = useQuery({
    queryKey: ["properties"],
    queryFn: async () => {
      const { data, error } = await fetchProperties();
      if (error) return [];
      return data || [];
    },
    enabled: isSupabaseConfigured(),
  });

  const propertiesSource = isSupabaseConfigured() && apiProperties.length > 0 ? apiProperties : properties;

  const locationOptions = useMemo(() => {
    const cities = [...new Set(propertiesSource.map((p) => p.city).filter(Boolean))];
    return cities.sort();
  }, [propertiesSource]);

  const filteredProperties = propertiesSource.filter((property) => {
    if (typeFilter !== "all" && (property.type || property.name) !== typeFilter) return false;
    if (locationFilter !== "all" && property.city !== locationFilter) return false;
    if (priceFilter !== "all") {
      const pv = Number(property.priceValue);
      if (priceFilter === "under1m" && pv >= 1000000) return false;
      if (priceFilter === "1m-2m" && (pv < 1000000 || pv > 2000000)) return false;
      if (priceFilter === "over2m" && pv <= 2000000) return false;
    }
    return true;
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-navy via-navy-dark to-navy">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
            Investment Properties
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Browse our premium multifamily properties with CMHC MLI Select
            financing
          </p>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 border-b border-border/40">
        <div className="container mx-auto px-4 max-w-7xl flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Filter className="h-5 w-5" />
            <span className="font-medium">Filter Properties:</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
            {/* Type Filter */}
            <Select value={typeFilter} onValueChange={setTypeFilter}>
              <SelectTrigger className="w-full sm:w-[180px]">
                <SelectValue placeholder="Property Type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Types</SelectItem>
                <SelectItem value="Duplex">Duplex</SelectItem>
                <SelectItem value="Fourplex">Fourplex</SelectItem>
                <SelectItem value="Sixplex">Sixplex</SelectItem>
                <SelectItem value="8-Unit Building">8-Unit Building</SelectItem>
              </SelectContent>
            </Select>

            {/* Location Filter (by city) */}
            <Select value={locationFilter} onValueChange={setLocationFilter}>
              <SelectTrigger className="w-full sm:w-[180px]">
                <SelectValue placeholder="Location" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Locations</SelectItem>
                {locationOptions.map((city) => (
                  <SelectItem key={city} value={city}>{city}</SelectItem>
                ))}
              </SelectContent>
            </Select>

            {/* Price Filter */}
            <Select value={priceFilter} onValueChange={setPriceFilter}>
              <SelectTrigger className="w-full sm:w-[180px]">
                <SelectValue placeholder="Price Range" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Prices</SelectItem>
                <SelectItem value="under1m">Under $1M</SelectItem>
                <SelectItem value="1m-2m">$1M - $2M</SelectItem>
                <SelectItem value="over2m">Over $2M</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </section>

      {/* Properties Grid */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-4 max-w-7xl">
          <p className="mb-8 text-muted-foreground">
            Showing{" "}
            <span className="font-semibold text-foreground">
              {filteredProperties.length}
            </span>{" "}
            {filteredProperties.length === 1 ? "property" : "properties"}
          </p>

          {filteredProperties.length === 0 ? (
            <div className="text-center py-16">
              <p className="text-xl text-muted-foreground">
                No properties match your filters. Try adjusting your criteria.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {filteredProperties.map((property) => (
                <Card
                  key={property.id}
                  className="overflow-hidden border-2 hover:border-accent transition-all duration-300 hover:shadow-luxury group"
                >
                  {/* Image */}
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={property.image}
                      alt={property.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />

                    <div className="absolute top-4 left-4 flex gap-2">
                      <Badge className="bg-primary text-accent font-semibold">
                        {property.type || property.name}
                      </Badge>

                      {property.status === "Featured" && (
                        <Badge className="bg-accent text-primary font-semibold">
                          Featured
                        </Badge>
                      )}
                    </div>

                    <div className="absolute top-4 right-4">
                      <Badge className="bg-white/90 text-primary font-bold text-lg px-4 py-2">
                        {property.price}
                      </Badge>
                    </div>
                  </div>

                  <CardHeader className="space-y-3">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-2xl font-bold text-primary mb-2">
                          {property.name}
                        </h3>
                        <div className="flex items-center gap-2 text-muted-foreground">
                          <MapPin className="h-4 w-4" />
                          <span>{property.location}</span>
                        </div>
                      </div>

                      {(property.units != null && property.units !== "") && (
                        <div className="text-right flex items-center gap-1 text-primary">
                          <Building2 className="h-5 w-5" />
                          <span className="font-semibold">
                            {property.units} Units
                          </span>
                        </div>
                      )}
                    </div>
                  </CardHeader>

                  <CardContent className="space-y-6">
                    {/* Highlights */}
                    <div className="grid grid-cols-2 gap-4 p-4 bg-accent/5 rounded-lg border border-accent/20">
                      <div>
                        <p className="text-sm text-muted-foreground mb-1">
                          Down Payment (5%)
                        </p>
                        <p className="text-lg font-bold text-primary">
                          {property.downPayment}
                        </p>
                      </div>

                      {property.monthlyRent != null && property.monthlyRent !== "" && (
                        <div>
                          <p className="text-sm text-muted-foreground mb-1">
                            Monthly Rent
                          </p>
                          <p className="text-lg font-bold text-accent">
                            {property.monthlyRent}
                          </p>
                        </div>
                      )}

                      <div>
                        <p className="text-sm text-muted-foreground mb-1">
                          Net Cash Flow
                        </p>
                        <p className="text-lg font-bold text-green-600">
                          {property.cashFlow}/mo
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-muted-foreground mb-1">
                          ROI
                        </p>
                        <p className="text-lg font-bold text-accent flex items-center gap-1 justify-center">
                          <TrendingUp className="h-4 w-4" />
                          {property.roi}
                        </p>
                      </div>
                    </div>

                    {property.equityGrowth != null && property.equityGrowth !== "" && (
                      <div className="p-4 bg-gradient-to-r from-accent/10 to-primary/10 rounded-lg border border-accent/30">
                        <p className="text-sm text-muted-foreground mb-1">
                          5-Year Equity Growth
                        </p>
                        <p className="text-xl font-bold text-primary">
                          {property.equityGrowth}
                        </p>
                      </div>
                    )}

                    {/* Key Features */}
                    <div>
                      <h4 className="font-semibold text-primary mb-3">
                        Key Features
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {property.features.map((feature, i) => (
                          <div
                            key={i}
                            className="flex items-center gap-2 text-sm"
                          >
                            <div className="w-1.5 h-1.5 rounded-full bg-accent"></div>
                            <span className="text-muted-foreground">
                              {feature}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* CTA */}
                    <Button
                      asChild
                      className="w-full bg-gradient-to-r from-accent to-accent-light hover:opacity-90 text-primary font-semibold"
                    >
                      <Link to={`/property/${property.id}`}>
                        Request Property Details
                        <ArrowRight className="ml-2 h-4 w-4" />
                      </Link>
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AllProperties;
